import { SenseType } from '../../../types/index.js';
export const parseVersionTag = (version) => {
    const senseTypes = {
        T: SenseType.TempSense,
        H: SenseType.HumiditySense,
        F: SenseType.FreezeSense
    };
    const senseType = senseTypes[version[0]];
    const major = parseInt(version.slice(1, 3), 16);
    const minor = parseInt(version.slice(3, 5), 16);
    return {
        senseType,
        firmwareVersion: `${major}.${minor}`
    };
};
export const isVersionHigherOrEqual = (currentVersion, minimumVersion) => {
    // Split versions into arrays of numbers
    const [currentMajor, currentMinor] = currentVersion.split('.').map(Number);
    const [minMajor, minMinor] = minimumVersion.split('.').map(Number);
    // Check if inputs are valid numbers
    if (isNaN(currentMajor) || isNaN(currentMinor) || isNaN(minMajor) || isNaN(minMinor)) {
        throw new Error('Invalid version format. Use X.Y where X and Y are numbers');
    }
    // Compare major version first
    if (currentMajor > minMajor)
        return true;
    if (currentMajor < minMajor)
        return false;
    // If major versions are equal, compare minor versions
    return currentMinor >= minMinor;
};
